<template>
    <q-dialog v-model="showModal">
        <q-card style="width: 400px;">
            <q-card-section class="row items-center q-pb-none">
                <div class="text-h6">{{$t('transfers.order_limit')}}</div>
                <q-space />
                <q-btn icon="close" flat round dense v-close-popup />
            </q-card-section>

            <q-card-section class="q-pt-none">
                <p>{{errorMessage}}</p>
            </q-card-section>

            <q-card-actions class="row q-col-gutter-md">
                <div class="col-12 text-right">
                    <q-btn :label="$t('ok')" color="primary" v-close-popup/>
                </div>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>
<script>

export default {
    name: "OrderLimitDialog",
    model: {
        prop: 'open',
        event: 'change'
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },

        errorMessage: {
            type: String,
            required: true
        }
    },
    computed: {
        showModal: {
            get: function () {
                return this.open
            },
            set: function (value) {
                this.$emit('change', value)
            }
        }
    },
    data() {
        return {

        }
    },
    methods: {},
    created() {
    },
    mounted() {
    },
    watch: {},
    components: {},
}
</script>
<style>

</style>
